<script setup>
defineProps({
  name: String,
  icon: Boolean,
  check: Boolean,
  settings: Boolean,
});

import Button from "@/components/ui/button/Button.vue";
import {
  ChevronLeftIcon,
  CircleCheck,
  SettingsIcon,
  Trash2Icon,
} from "lucide-vue-next";

import { useRouter } from "vue-router";
const router = useRouter();

</script>

<template>
  <div class="flex space-x-2 h-12 items-center">
    <Button 
    class="flex h-12 items-center" 
    variant="ghost" 
    size="sm"
    @click="() => router.back()"
      ><ChevronLeftIcon class="w-6 h-6"
    /></Button>
    <CircleCheck
      v-if="check === true"
      class="text-primary w-6 h-6 pb-1"
    ></CircleCheck>
    <h1
      class="scroll-m-20 text-xl font-semibold text-balance self-center mb-1 grow"
    >
      {{ name }}
    </h1>
    <Button
      v-if="icon === true"
      class="flex h-12 items-center"
      variant="ghost"
      size="sm"
      @click="() => $emit('removeSeat')"
    >
      <Trash2Icon class="w-6 h-6" />
    </Button>
    <Button
      v-if="settings === true"
      class="flex h-12 items-center"
      variant="ghost"
      size="sm"
    >
      <SettingsIcon class="w-6 h-6" />
    </Button>
  </div>
</template>
